<template><UserAgreementEditorBase agreement-type="Extension Agreement" /></template>
<script>
import UserAgreementEditorBase from '@/views/user/UserAgreementEditorBase'
export default { name: 'UserExtensionAgreement', components: { UserAgreementEditorBase } }
</script>
